import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { installStaleChunkReload } from './lib/stale-chunk';
import { ThemeProvider } from './lib/theme';

// A tab open across a deploy reloads once rather than break (lib/stale-chunk.ts).
installStaleChunkReload();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
